import app from "../App";

const defaultLocaleLoader = async lang => await import(/* webpackChunkName: "lang-[request]" */ `@lang/${lang}.json`);

const productLocaleLoader = async (settings, lang) => {
    try {
        return await import(/* webpackChunkName: "lang-[request]" */ `@lang/${settings?.product}/${lang}.json`);
    } catch {
        return;
    }
};

export default container => {
    // create the main vue instance depending on those services
    container.declare("app", async ({Vue, i18n, modal, router, settings, store}) => {
        // subscribe to set language
        i18n.subscribeLoad(defaultLocaleLoader);
        i18n.subscribeLoad(productLocaleLoader.bind(null, settings));

        // set and load default and fallback languages
        const {languages} = settings;
        await i18n.loadLanguage(languages.fallback);
        await i18n.setLanguage(languages.default);
        // start main machine
        store.start();

        //setting the router authentication guard
        router.beforeEach(
            function(store, to, from, next) {
                if (to.name !== "login" && !store.service.machine.context.isAuthenticated) {
                    next({name: "login", query: {redirect: to.name}});
                } else {
                    store.service.send.call(store.service, `GOTO_${to.name}`);
                    next();
                }
            }.bind(this, store)
        );

        Vue.prototype.$modal = modal;

        // create the instance of vue to be mounted in the DOM for standalone purpose
        new Vue({
            i18n,
            router: router,
            render: h => h(app),
        }).$mount("#app");
    });
};
